export default __webpack_public_path__ + "static/media/simple-icon.673b7e17.svg";